import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { PageName } from 'src/app/shared/utils/user-roles';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { SiteManagerComponent } from 'src/app/site-management/site-manager/site-manager.component';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { CreateUserComponent } from './create-user/create-user.component';
import { AccessPoint, IAccessPoint } from './activity/access-point-interfaces';
import { EditAccesspointDetailsComponent } from 'src/app/floor-management/edit-accesspoint-details/edit-accesspoint-details.component';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import {
  convertDateTimeFormat,
  convertNumberToWords,
  convertParseDateTime,
  Utility,
} from 'src/app/shared/utils/utility.service';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from 'src/app/shared/state-management/state-interfaces';
import { IDevice } from './add-lock/lock-management-interfaces';
import { AddLockComponent } from './add-lock/add-lock.component';
import { DeviceSettingsComponent } from '../device-settings/device-settings.component';
import { DeviceManagementComponent } from './device-management/device-management.component';
import { BuildingManagementService } from '../building-management.service';
import { IUser } from 'src/app/user-management/user-management-interfaces';
import { RestrictRemoveDialogComponent } from 'src/app/shared-layout/Components/restrict-remove-dialog/restrict-remove-dialog.component';
import { CommonService } from 'src/app/shared/utils/common.service';
import { ViewAllItemComponent } from 'src/app/shared-layout/Components/activity/view-all-item/view-all-item.component';
import {
  Activities,
  IActivityFilterCriteria,
} from 'src/app/shared-layout/Components/activity/activity.interface';
import { MatDialogRef } from '@angular/material/dialog';
import { AccessPointFilterActvityComponent } from 'src/app/shared-layout/Components/activity/access-point-filter-actvity/access-point-filter-actvity.component';
import { ViewAlertDetailsComponent } from './view-alert-details/view-alert-details.component';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { map, tap } from 'rxjs/operators';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-building-unit-details',
  templateUrl: './building-unit-details.component.html',
  styleUrls: ['./building-unit-details.component.scss'],
})
export class BuildingUnitDetailsComponent implements OnInit, OnDestroy {
  deviceLength: string | undefined;
  sharedData: any;
  subscription: Subscription | undefined;
  DeviceListSubscription: Subscription | undefined;
  PartnerDeviceListSubscription: Subscription | undefined;
  deviceList!: Observable<IDevice[] | undefined>;
  partnerDeviceList: any = [];
  usersList!: Observable<IUser[] | undefined>;
  floorName: String = '';
  selectedUnitId!: string; //for local variable reason: back to back server hit
  accessPointActivityPageSize = 15;
  canLoad = false;
  AccessPointActivityCount: number = 0;
  batteryError: string = '';
  commonAccessControl!: boolean;

  CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  error: boolean = false;
  message = '';

  PageName = PageName;
  @Input() selectedSite: any;
  @Input() selectedBuilding: any;
  @Input() selectedFloor: any;
  @Input() selectedUnit: any;
  selectedAccessPoint!: IAccessPoint;
  unitDetails: any;
  activeTab = '';
  accessPoints: AccessPoint | undefined;
  floorManagemetSubscription: Subscription | undefined;
  type: string = '';
  deviceListCopy: any = [];
  partnerDeviceListCopy: any = [];
  accessPointActivities!: Observable<any[]>;
  serverAccessPointActivityCount: number | undefined;
  unitActivities!: Observable<any[]>;
  restrictedUnitsObservable!: Observable<any[]>;
  restrictedAccessObservable!: Observable<any[]>;

  serverUnitActivityCount: number | undefined;
  filterActivity: any;
  filterCount: number = 0;
  deviceCount: number = 0;
  partnerDeviceCount: number = 0;
  partnerDeviceResponse: any = [];
  filterCriteria: IActivityFilterCriteria = {
    eventCode: [],
    dateTo: null,
    dateFrom: null,
    pagination: {
      cursor: [],
      size: 20,
    },
  };
  activityData: any;
  isNestedCallActive: boolean = false;
  isActivityNestedCallActive: boolean = false;
  isNestedSubLoaderCallActive: boolean = false;
  doorDeviceId!: string;
  floorManagementSubscription: Subscription | undefined;
  restrictedEventsSubject = new BehaviorSubject<any[]>([]);
  constructor(
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    private floorManagementService: FloorManagementService,
    private notificationService: NotificationService,
    private ngRedux: NgRedux<IAppState>,
    private buildingManagementService: BuildingManagementService,
    private commonService: CommonService,
    private stateManagementService: StateManagementService,
    public dialogRef: MatDialogRef<CreateUserComponent>,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    /**
     * This service is resposible when record updating, we previously using this service in floor-management list rendering also in get update record case
     */
    this.floorManagementSubscription =
      this.floorManagementService?.triggerRerender?.subscribe(
        (result: boolean) => {
          if (result) {
            this.selectedUnitId = '';
            this.ngOnInit();
            this.floorManagementService.setTriggerRerender(false);
          }
        }
      );

    this.ngRedux?.select('deviceList')?.subscribe((res: any) => {
      if (JSON.stringify(res) !== JSON.stringify(this.deviceList)) {
        this.deviceCount = res?.filter((device: any) => {
          return device?.activationState !== CONSTANTS.DEACTIVATED;
        }).length;
        this.deviceList = res;
        this.deviceListCopy = res;
      }
    });
    this.ngRedux?.select('partnerDeviceList')?.subscribe((res: any) => {
      if (JSON.stringify(res) !== JSON.stringify(this.partnerDeviceList)) {
        this.partnerDeviceCount = res?.filter((device: any) => {
          return device?.activationState !== CONSTANTS.PENDING_DEACTIVATION;
        }).length;

        this.partnerDeviceList = res;
        this.partnerDeviceListCopy = res;
        let tempPartnerList = res;
        let partnerControllerDoorList = [];
        let partnerOtherDevicesList = [];

        for (let i = 0; i < tempPartnerList.length; i++) {
          const device = tempPartnerList[i];
          if (
            device.deviceType === CONSTANTS.PARTNER_DEVICETYPE_DOOR ||
            device.deviceType === CONSTANTS.PARTNER_DEVICE_CONTROLLER
          ) {
            partnerControllerDoorList.push(device);
          } else {
            partnerOtherDevicesList.push(device);
          }
        }
        this.partnerDeviceList = [
          ...partnerControllerDoorList,
          ...partnerOtherDevicesList,
        ];
        this.partnerDeviceListCopy = [
          ...partnerControllerDoorList,
          ...partnerOtherDevicesList,
        ];
        if (this.partnerDeviceList.length > 0) {
          let index = this.partnerDeviceList.findIndex(
            (x: { deviceId: string }) => !x.deviceId.match(CONSTANTS.HYPHEN)
          );
          this.partnerDeviceList.splice(
            0,
            0,
            this.partnerDeviceList.splice(index, 1)[0]
          );
          this.stateManagementService.updatePartnerDeviceList(
            this.partnerDeviceList
          );

          const doorDevice = this.partnerDeviceList.find(
            (x: { deviceType: string }) => x.deviceType === CONSTANTS.DOOR
          );
          if (doorDevice) {
            this.doorDeviceId = doorDevice.deviceId;
          }
        }
      }
    });
    this.ngRedux
      .select('unitOrAccessPointUserList', Utility.compareTwoStoreStates)
      .subscribe((usersList: any) => {
        if (usersList && usersList.length > 0) {
          this.usersList = of(usersList);
        } else {
          this.usersList = of([]);
        }
      });
    this.accessPointActivities = this.ngRedux.select('accessPointActivities');
    this.unitActivities = this.ngRedux.select('unitActivities');
  }

  /**
   * @description: runs on when component is initialized. This method subscribes sharedDataService,
   *                and call getUnitsByFloor method of FloorManagementService.
   * @input {none}
   * @output {void}
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        this.commonAccessControl =
          this.sharedData.selectedSite.commonAccessControl;
        !this.commonAccessControl
          ? (this.message = this.translate.instant('PLEASE_SELECT_A_UNIT'))
          : (this.message = this.translate.instant(
              'PLEASE_SELECT_A_UNIT_OR_ACCESSPOINT'
            ));
        if (
          this.sharedData.selectedUnit?.unitId &&
          this.sharedData.selectedUnit?.unitId !== this.selectedUnitId
        ) {
          this.commonService.setLoadingUnitAndAccessPoint(true);
          this.activeTab = CONSTANTS.LOCKS;
          this.selectedUnitId = this.sharedData.selectedUnit.unitId;
          //starting loader
          this.isNestedCallActive = true;
          /* Get Users from unit */
          this.buildingManagementService
            .getUserViaUnit(this.selectedUnitId, true, true)
            .subscribe();
          this.floorManagemetSubscription = this.floorManagementService
            .getUnit(
              this.sharedData?.selectedSite?.siteId,
              this.selectedBuilding?.buildingId,
              this.sharedData?.selectedFloor?.floorId,
              this.sharedData?.selectedUnit?.unitId,
              true
            )
            .subscribe({
              next: (res: any) => {
                const { unitId, unitName } = res;
                // update building name MPC-9326
                this.sharedDataService.setSelectedUnit({ unitId, unitName });
                this.floorManagementService
                  .getDeviceByUnitId(
                    this.sharedData?.selectedUnit?.unitId,
                    true,
                    true
                  )
                  .subscribe({
                    next: (res) => {
                      this.commonService.setLoadingUnitAndAccessPoint(false);
                      this.isNestedCallActive = false;
                    },
                    error: (err) => {
                      this.isNestedCallActive = false;
                    },
                  });
                this.activeTab = CONSTANTS.LOCKS;
                this.type = CONSTANTS.UNIT;
                this.unitDetails = res;
                this.accessPoints = undefined;
                this.selectedAccessPoint = {
                  accessPointId: '',
                } as IAccessPoint;
                this.initializeFilter();
                this.filterCount = 0;
              },
              error: (err: Error) => {
                if (window.__dev__) console.log('Get Unit: ', err);
                this.isNestedCallActive = false;
              },
            });

          this.resetFilters();
          this.getUnitActivity();
        } else if (
          this.sharedData?.selectedAccessPoint?.accessPointId &&
          this.selectedAccessPoint?.accessPointId !==
            this.sharedData.selectedAccessPoint?.accessPointId
        ) {
          this.commonService.setLoadingUnitAndAccessPoint(true);

          this.activeTab = CONSTANTS.DEVICE;
          this.selectedAccessPoint = this.sharedData.selectedAccessPoint;
          /**
           * for access point logic
           */
          this.getAccessPoints();

          this.isNestedCallActive = true;
          this.getAccessPointActivity();
          /* Get Users from Accesspoint */
          this.buildingManagementService
            .getUserViaAccessPoint(
              this.selectedAccessPoint?.accessPointId,
              true
            )
            .subscribe({
              next: () => {
                this.isNestedCallActive = false;
              },
              error: () => {
                this.isNestedCallActive = false;
              },
            });
        } else {
          this.commonService.setLoadingUnitAndAccessPoint(false);
        }
      }
    );
    this.initializeFilter();
  }

  /**
   * @description: This method accepts the floor in string and check if the floor has any number.
   * @input { string }
   * @param { floor }
   * @output { boolean }
   */

  stringContainsNumber(floor: string) {
    return /\d/.test(floor);
  }

  /**
   * @description: onRemoveUnit function opens the modal poup for remove unit.
   * @input none
   * @output { void }
   */

  onRemoveUnit(): void {
    if (this.unitDetails?.unitStatus === CONSTANTS.PENDING_DELETE) {
      this.notificationService.showError(
        this.translate.instant('UNIT_IS_ALREADY_IN_PENDING_DELETE_STATE')
      );
      return;
    } else if (this.deviceListCopy?.length > 0) {
      let bodyText = this.translate.instant('RESTRICT_REMOVE_UNIT');
      let argumentList = [this.sharedData?.selectedUnit?.unitName];
      if (this.deviceListCopy?.length === 1) {
        argumentList.push(this.translate.instant('IS'));
        this.deviceLength = convertNumberToWords(this.deviceListCopy?.length);
        argumentList.push(this.deviceLength);
        argumentList.push(this.translate.instant('LOCK)'));
      } else {
        argumentList.push(this.translate.instant('ARE'));
        this.deviceLength = convertNumberToWords(this.deviceListCopy?.length);
        argumentList.push(this.deviceLength);
        argumentList.push(
          this.translate.instant('MULTIPLE_LOCKS').toLowerCase()
        );
      }
      for (let i = 0; i < this.deviceListCopy?.length; i++) {
        argumentList.push(this.deviceListCopy[i]?.deviceName);
        bodyText += ' "{}"';
        bodyText += i === this.deviceListCopy?.length - 1 ? '.' : ',';
      }
      bodyText = this.commonService.stringInterPolation(bodyText, argumentList);
      this.helperService.openModalDialog(
        RestrictRemoveDialogComponent,
        {
          title: this.translate.instant('DELETE_UNIT'),
          subTitle: this.commonService.stringInterPolation(
            this.translate.instant('UNABLE_TO_REMOVE_UNIT'),
            this.sharedData?.selectedUnit?.unitName
          ),
          bodyText: bodyText,
          footerText: this.translate.instant(
            'TO_REMOVE_LOCKS_FROM_A_UNIT_YOU_MUST_USE_THE_PROPERTY_MANAGER_MOBILE'
          ),
        },
        CONSTANTS.FIXED_SCREEN_MODAL
      );
    } else {
      this.helperService
        .openModalDialog(
          SiteManagerComponent,
          { defaultNavigation: CONSTANTS.REMOVE_UNIT },
          CONSTANTS.FIXED_SCREEN_MODAL
        )
        .afterClosed()
        .subscribe((result: boolean) => {
          if (result) {
            this.floorManagementService.setTriggerRerender(true);
          }
        });
    }
  }
  /**
   * @description: onEditUnit function function opens the modal poup for Edit unit.
   * @input none
   * @output { void }
   */

  onEditHandler(): void {
    if (this.type === CONSTANTS.UNIT) {
      this.helperService.openModalDialog(
        SiteManagerComponent,
        { enableBackOperation: false, defaultNavigation: CONSTANTS.EDIT_UNIT },
        CONSTANTS.FIXED_SCREEN_MODAL
      );
    } else if (this.type === CONSTANTS.ACCESSPOINT) {
      const dialogInstance = this.helperService.openModalDialog(
        EditAccesspointDetailsComponent,
        {
          accessPoint: this.accessPoints,
          siteId: this.selectedSite?.siteId,
          buildingId: this.selectedBuilding?.buildingId,
          floorId: this.selectedFloor?.floorId,
          buildingName: this.selectedBuilding?.buildingName,
        },
        CONSTANTS.FIXED_SCREEN_MODAL
      );
    }
  }

  /**
   * @description: #addDevice Function will open the modal for assigning a device
   * @inut {none}
   * @output {void}
   */
  addDevice(): void {
    const dialogInstance = this.helperService.openModalDialog(
      DeviceManagementComponent,
      {
        accessPointId: this.sharedData?.selectedAccessPoint?.accessPointId,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }

  /**
   * @description get access points of user
   * @returns void
   */
  getAccessPoints(): void {
    this.activeTab = CONSTANTS.DEVICE;
    this.isNestedSubLoaderCallActive = true;
    this.floorManagemetSubscription = this.floorManagementService
      .getAccessPoints(
        this.sharedData?.selectedSite?.siteId,
        this.selectedBuilding?.buildingId,
        this.sharedData?.selectedFloor?.floorId,
        this.sharedData?.selectedAccessPoint?.accessPointId,
        true
      )
      .subscribe({
        next: (res: AccessPoint) => {
          this.floorManagementService
            .getPartnerDevicesByAccessPoint(
              this.sharedData?.selectedAccessPoint?.accessPointId,
              true
            )
            .subscribe({
              next: () => {
                this.commonService.setLoadingUnitAndAccessPoint(false);
                this.isNestedSubLoaderCallActive = false;
              },
              error: () => {
                this.isNestedSubLoaderCallActive = false;
              },
            });
          this.type = CONSTANTS.ACCESSPOINT;
          this.accessPoints = res;
          this.selectedUnitId = '';
          this.initializeFilter();
          this.filterCount = 0;
        },
        error: (err: any) => {
          if (window.__dev__) console.log(err);
        },
      });
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the sharedDataService service
   * @input {none}
   * @output {void}
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.floorManagemetSubscription?.unsubscribe();
    this.DeviceListSubscription?.unsubscribe();
    this.PartnerDeviceListSubscription?.unsubscribe();
    this.floorManagementSubscription?.unsubscribe();
  }

  /**
   * @description: onRemove Access point function opens the modal poup for remove unit.
   * @input none
   * @output { void }
   */

  onRemoveAccessPoint(): void {
    if (this.partnerDeviceListCopy?.length > 0) {
      let bodyText = this.translate.instant('RESTRICT_REMOVE_ACCESSPOINT');
      let argumentList = [
        this.sharedData?.selectedAccessPoint?.accessPointName,
      ];
      if (this.partnerDeviceListCopy?.length === 1) {
        argumentList.push(this.translate.instant('IS'));
        argumentList.push(this.partnerDeviceListCopy?.length);
        argumentList.push(this.translate.instant('DEVICE').toLowerCase());
      } else {
        argumentList.push(this.translate.instant('ARE'));
        argumentList.push(this.partnerDeviceListCopy?.length);
        argumentList.push(this.translate.instant('DEVICES').toLowerCase());
      }
      for (let i = 0; i < this.partnerDeviceListCopy?.length; i++) {
        argumentList.push(this.partnerDeviceListCopy[i]?.deviceName);
        bodyText += ' "{}"';
        bodyText += i === this.partnerDeviceListCopy?.length - 1 ? '.' : ',';
      }
      bodyText = this.commonService.stringInterPolation(bodyText, argumentList);
      this.helperService.openModalDialog(
        RestrictRemoveDialogComponent,
        {
          title: this.translate.instant('DELETE_ACCESS_POINT'),
          subTitle: this.commonService.stringInterPolation(
            this.translate.instant('UNABLE_TO_REMOVE_ACCESS_POINT'),
            this.sharedData?.selectedAccessPoint?.accessPointName
          ),
          bodyText: bodyText,
          footerText: !this.commonAccessControl
            ? ''
            : this.translate.instant(
                'TO_REMOVE_DEVICES_FROM_AN_ACCESS_POINT_YOU_MUST_USE_THE_PROPERTY_MANAGER_MOBILE'
              ),
        },
        CONSTANTS.FIXED_SCREEN_MODAL
      );
    } else {
      this.helperService
        .openModalDialog(
          SiteManagerComponent,
          { defaultNavigation: CONSTANTS.REMOVE_UNIT, removeAP: true },
          CONSTANTS.FIXED_SCREEN_MODAL
        )
        .afterClosed()
        .subscribe((result: boolean) => {
          if (result) {
            this.floorManagementService.setTriggerRerender(true);
          }
        });
    }
  }

  /**
   * @description: #navigateToPartnerDeviceInfo function opens the modal poup for Partner Device Settings.
   * @param { string } deviceId
   * @param { string } deviceName
   * @param { string } entity
   * @output { void }
   */

  navigateToPartnerDeviceInfo(
    deviceId: string,
    deviceName: string,
    deviceType: string,
    entity: string
  ): void {
    this.helperService.openModalDialog(
      DeviceSettingsComponent,
      {
        deviceId,
        doorDeviceId: this.doorDeviceId,
        deviceName,
        deviceType,
        accessPointId: this.selectedAccessPoint?.accessPointId,
        accessPointName: this.selectedAccessPoint?.accessPointName,
        parentType: entity,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }

  /**
   * @description: #viewAllAccessPointActivity function opens the modal poup for viewing all activities.
   * @output { void }
   */
  viewAllUnitsOrAccessPointActivity(): void {
    const dialogRef = this.helperService.openModalDialog(
      ViewAllItemComponent,
      {
        filterCount: this.filterCount,
        filter: this.filterActivity,
        title: this.selectedAccessPoint?.accessPointName,
        type: this.accessPoints ? CONSTANTS.ACCESSPOINT : CONSTANTS.UNIT,
        scroll: true,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );

    dialogRef.afterClosed().subscribe((activityData: any) => {
      this.filterActivity = activityData.filter;
      this.filterCount = activityData.filterCount;
    });
  }

  /**
   * @description open modal and show filter activity
   * @returns void
   */
  accessPointActivityFilter(): void {
    const dialogInstance = this.helperService.openModalDialog(
      AccessPointFilterActvityComponent,
      this.filterActivity,
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((filter: any) => {
      if (filter) {
        this.filterActivity = filter;
        const userCount = this.filterActivity.users != '' ? 1 : 0;
        const dateCount = this.filterActivity?.dates ? 1 : 0;
        this.filterCount =
          this.filterActivity?.lockType.length || 0 + userCount + dateCount;

        this.filterCriteria.searchEntity = JSON.stringify({
          user: filter?.users,
        });

        if (filter?.dates?.start && filter?.dates?.end) {
          this.filterCriteria.dateFrom = convertDateTimeFormat(
            filter?.dates?.start,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
          this.filterCriteria.dateTo = convertDateTimeFormat(
            filter?.dates?.end,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
        } else {
          this.filterCriteria.dateFrom = null;
          this.filterCriteria.dateTo = null;
        }

        this.filterCriteria.eventCode = filter?.lockIds;
        this.accessPoints
          ? this.getAccessPointActivity()
          : this.getUnitActivity();
      } else {
        if (
          this.filterActivity?.dates?.start &&
          this.filterActivity?.dates?.end
        ) {
          this.filterCriteria.dateFrom = convertDateTimeFormat(
            this.filterActivity?.dates?.start,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
          this.filterCriteria.dateTo = convertDateTimeFormat(
            this.filterActivity?.dates?.end,
            "yyyy-MM-dd'T'HH:mm:ss"
          );
        } else {
          this.filterCriteria.dateFrom = null;
          this.filterCriteria.dateTo = null;
        }
        this.filterCriteria.eventCode = this.filterActivity?.lockIds;
        this.accessPoints
          ? this.getAccessPointActivity()
          : this.getUnitActivity();
      }
    });
  }

  /**
   * @description #initializeFilter function gets the floorList from app and
   *               map the data int the required state of filter component.
   * @returns void
   */
  initializeFilter(): void {
    this.filterActivity = {
      users: '',
      dates: '',
      lockType: [],
      entityType: this.accessPoints ? CONSTANTS.ACCESSPOINT : CONSTANTS.UNIT,
    };
  }

  /**
   * @description get access point activity and store into data
   */
  getAccessPointActivity(): void {
    this.isActivityNestedCallActive = true;
    this.filterCriteria.siteId = this.sharedData?.selectedSite?.siteId;
    this.floorManagementService
      .getEventHistoryByAccessPoint(
        this.sharedData?.selectedAccessPoint?.accessPointId,
        this.filterCriteria,
        false,
        true
      )
      .subscribe((res: any) => {
        this.isActivityNestedCallActive = false;
        this.filterActivity.entityType = CONSTANTS.ACCESSPOINT;
        this.accessPointActivities.subscribe((response: any) => {
          const restrictedEvents = {
            ...response,
            events: response.events.slice(0, 10),
          };
          this.restrictedEventsSubject.next(restrictedEvents);
        });
        this.restrictedAccessObservable =
          this.restrictedEventsSubject.asObservable();
      });
  }

  /**
   * @description get access point activity and store into data
   */
  getUnitActivity(): void {
    this.isActivityNestedCallActive = true;
    this.floorManagementService
      .getEventHistoryByUnit(
        this.sharedData?.selectedUnit?.unitId,
        this.filterCriteria,
        false,
        true
      )
      .subscribe((res: any) => {
        this.isActivityNestedCallActive = false;
        this.filterActivity.entityType = CONSTANTS.UNIT;
        this.unitActivities.subscribe((response: any) => {
          const restrictedEvents = {
            ...response,
            events: response.events.slice(0, 10),
          };
          this.restrictedEventsSubject.next(restrictedEvents);
        });
        this.restrictedUnitsObservable =
          this.restrictedEventsSubject.asObservable();
      });
  }

  /**
   * @description: #getBatteryPercentage function recieves battery percentage in string and converts it to number.
   * @param { string } batteryPercentage
   * @returns { number } battery
   */

  getBatteryPercentage(batteryPercentage: string): number {
    batteryPercentage = batteryPercentage?.replace('%', '');
    return parseInt(batteryPercentage);
  }

  /**
   * @description: #getPartnerDeviceLockImg function recieves battery deviceState and returns the image src
   * @param { string } deviceState
   * @returns { string } src
   */
  getPartnerDeviceLockImg(deviceState: string): string {
    let imageType = '';
    switch (deviceState) {
      case CONSTANTS.OFFLINE:
        imageType = 'ico-lock-circle-outline-red.svg';
        break;
      case CONSTANTS.ONLINE:
        imageType = 'ico-home-lock.svg';
        break;
      case '':
        imageType = 'ico-lock-gray-circle.svg';
        break;
      default:
        imageType = 'ico-lock-gray-circle.svg';
        break;
    }
    return '/assets/svg/' + imageType;
  }

  ngDestroy(): void {
    this.subscription?.unsubscribe();
    this.floorManagemetSubscription?.unsubscribe();
  }

  /**
   * @description: resets the filter criteria, filter count and filter activity
   */
  private resetFilters(): void {
    this.filterCriteria = {
      eventCode: [],
      dateTo: null,
      dateFrom: null,
      pagination: {
        cursor: [],
        size: 10,
      },
    };
    this.filterActivity = {
      users: '',
      dates: '',
      lockType: [],
      entityType: 'Unit',
    };
    this.filterCount = 0;
  }
}
